/*! @azure/msal-common v14.16.0 2025-01-14 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-common";
const version = "14.16.0";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
